module.exports = __webpack_public_path__ + "img/png1.5d0f066b.png";